import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext.tsx';
import { supabase } from '../lib/supabase.ts';
import { useHistory } from 'react-router-dom';
import LoginModal from './LoginModal.tsx';

interface AuthRequiredRouteProps {
  children: React.ReactNode;
}

const AuthRequiredRoute: React.FC<AuthRequiredRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const history = useHistory();
  const [profileCompleted, setProfileCompleted] = useState<boolean | null>(null);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const checkProfile = async () => {
      if (!user) {
        if (isMounted) {
          setProfileCompleted(true);
          setShowLoginModal(true);
        }
        return;
      }
      if (isMounted) setProfileCompleted(true);
    };

    if (!loading) {
      checkProfile();
    }

    return () => {
      isMounted = false;
    };
  }, [user, loading, history]);

  if (loading || profileCompleted === null) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontFamily: "'Crimson Text', serif",
        }}
      >
        로딩 중...
      </div>
    );
  }

  if (!user) {
    return (
      <>
        <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
        {children}
      </>
    );
  }

  if (!profileCompleted) {
    return null;
  }

  return <>{children}</>;
};

export default AuthRequiredRoute;
